import { Root as VisuallyHidden } from '@radix-ui/react-visually-hidden'
import clsx from 'clsx'
import { isSameDay } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { formatDate, formatTime } from '@/utils/format-date'

import styles from './SchoolProgramme.module.scss'
import type { SchoolProgrammeEvent as SchoolProgrammeEventType } from '../constants/timetable-events'

export type SchoolProgrammeEventProps = SchoolProgrammeEventType

const SchoolProgrammeEvent = (props: SchoolProgrammeEventProps) => {
  const { t } = useTranslation('timetable')

  const isOneDayEvent = isSameDay(props.startDate, props.endDate)

  const timeText = isOneDayEvent
    ? formatTime(props.startDate) + '—' + formatTime(props.endDate)
    : `${formatTime(props.startDate)} ${formatDate(props.startDate)} — ${formatTime(props.endDate)} ${formatDate(props.endDate)}`

  return (
    <div className={clsx(styles.event)}>
      <VisuallyHidden>{formatDate(props.startDate)}</VisuallyHidden>
      <div className={styles.eventHeader}>
        <span className={styles.eventTitle}>{props.title}</span>
      </div>

      <span className={styles.eventText}>{timeText}</span>

      {props.room ? (
        <span className={styles.eventText}>
          {t('text.room')}: {props.room.name}
        </span>
      ) : null}
    </div>
  )
}
export default SchoolProgrammeEvent
